import React, { useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PhoneDisplay } from "@/components/PhoneDisplay";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { SimammaBadge } from "@/components/Logo";
import { toast } from "sonner";
import { Search, Wallet, Signal, CalendarClock } from "lucide-react";

export default function SimInfo() {
  const [msisdn, setMsisdn] = useState("");
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const lookup = async (e) => {
    e.preventDefault();
    setLoading(true); setInfo(null);
    try {
      const { data } = await api.get("/simamma/sim-info", { params: { msisdn } });
      setInfo(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="sim-info-page">
      <div>
        <div className="flex items-center gap-2"><SimammaBadge /><span className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Servizio operatore</span></div>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-2" data-testid="simamma-info-title">Info SIM SiMamma</h1>
      </div>

      <Card className="p-5 glow-border">
        <form onSubmit={lookup} className="flex flex-wrap gap-3 items-end">
          <div className="flex-1 min-w-0 basis-52">
            <Label>Numero SiMamma</Label>
            <Input type="tel" className="mt-1.5" data-testid="siminfo-msisdn-input" value={msisdn} onChange={(e) => setMsisdn(e.target.value)} placeholder="+39 3xx xxxxxxx" />
          </div>
          <Button type="submit" disabled={loading} className="gap-2" data-testid="siminfo-lookup-button">
            <Search className="w-4 h-4" /> {loading ? "Ricerca…" : "Cerca"}
          </Button>
        </form>
      </Card>

      {info && (
        <Card className="p-6 glow-border" data-testid="siminfo-result">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Numero</p>
              <p className="font-head text-2xl font-bold"><PhoneDisplay value={info.msisdn} data-testid="siminfo-phone" /></p>
            </div>
            <Badge className={info.status === "attiva" ? "bg-teal-600 hover:bg-teal-600" : "bg-amber-500 hover:bg-amber-500"}>{info.status}</Badge>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-6">
            <div className="rounded-xl border border-border p-4">
              <Wallet className="w-4 h-4 text-primary" /><p className="text-xs text-muted-foreground mt-2">Credito</p>
              <p className="font-head text-xl font-bold">{euro(info.credit)}</p>
            </div>
            <div className="rounded-xl border border-border p-4">
              <Signal className="w-4 h-4 text-primary" /><p className="text-xs text-muted-foreground mt-2">Giga residui</p>
              <p className="font-head text-xl font-bold">{info.data_remaining_gb} GB</p>
            </div>
            <div className="rounded-xl border border-border p-4">
              <CalendarClock className="w-4 h-4 text-primary" /><p className="text-xs text-muted-foreground mt-2">Rinnovo</p>
              <p className="font-head text-xl font-bold">{info.renewal_in_days}g</p>
            </div>
          </div>
          <p className="text-sm mt-4"><span className="text-muted-foreground">Offerta attiva:</span> <span className="font-medium">{info.plan}</span></p>
        </Card>
      )}
    </div>
  );
}
